import './Profile.css';
import Username from '../../../Components/Username/Username';
import EditableInfo from '../../../Components/EditableInfo/EditableInfo';
import EditableAvatar from '../../../Components/EditableAvatar/EditableAvatar';
import { editInfo } from '../../../reducer/profileActions';
import { useProfile } from 'context/ProfileContext';

const Profile = () => {
    const { state, dispatch } = useProfile();

    return (
        <div className="signature-composition">
            <div className="signature-portrait">
                <EditableAvatar />
            </div>

            <EditableInfo
                currentInfo={state.currentProfile.info as { title?: string; description?: string }}
                onHandleEditInfo={(type, value) => editInfo(dispatch, type, value)}
            />

            <div className="signature-username-row">
                <Username />
            </div>
        </div>
    );
};

export default Profile;
